import { create } from 'zustand';
import { EstadosService } from '../services/estados.service';
import { useLoadingStore } from './loadingStore';
import { useAlertStore } from './alertStore';

interface EstadosState {
  estadosInternos: Record<string, number>;
  estadosInternosInverso: Record<number, string>;
  estadosMP: Record<string, number>;
  estadosMPInverso: Record<number, string>;
  isLoadedInternos: boolean;
  isLoadedMP: boolean;
  isLoading: boolean;
  setEstadosInternos: (estados: Record<string, number>) => void;
  setEstadosMP: (estados: Record<string, number>) => void;
  fetchEstadosInternos: () => Promise<void>;
  fetchEstadosMP: () => Promise<void>;
  fetchAllEstados: () => Promise<void>;
}

export const useEstadosStore = create<EstadosState>((set, get) => ({
  estadosInternos: {},
  estadosInternosInverso: {},
  estadosMP: {},
  estadosMPInverso: {},
  isLoadedInternos: false,
  isLoadedMP: false,
  isLoading: false,
  
  setEstadosInternos: (estados) => {
    const estadosInternosInverso = Object.fromEntries(
      Object.entries(estados).map(([nombre, codigo]) => [codigo, nombre])
    );
    set({ 
      estadosInternos: estados, 
      estadosInternosInverso,
      isLoadedInternos: true 
    });
  },
  
  setEstadosMP: (estados) => {
    const estadosMPInverso = Object.fromEntries(
      Object.entries(estados).map(([nombre, codigo]) => [codigo, nombre])
    );
    set({ 
      estadosMP: estados, 
      estadosMPInverso,
      isLoadedMP: true 
    });
  },

  fetchEstadosInternos: async () => {
    const state = get();
    if (state.isLoadedInternos) return;
    
    try {
      const data = await EstadosService.obtenerEstadosInternos();
      state.setEstadosInternos(data);
    } catch (error) {
      const showAlert = useAlertStore.getState().showAlert;
      showAlert(error instanceof Error ? error.message : 'Error al cargar estados internos', 'error');
    }
  },

  fetchEstadosMP: async () => {
    const state = get();
    if (state.isLoadedMP) return;
    
    try {
      const data = await EstadosService.obtenerEstados();
      state.setEstadosMP(data);
    } catch (error) {
      const showAlert = useAlertStore.getState().showAlert;
      showAlert(error instanceof Error ? error.message : 'Error al cargar estados MP', 'error');
    }
  },

  fetchAllEstados: async () => {
    const state = get();
    if (state.isLoading || (state.isLoadedInternos && state.isLoadedMP)) return;
    
    set({ isLoading: true });
    const setLoading = useLoadingStore.getState().setLoading;
    setLoading(true);
    
    try {
      await state.fetchEstadosMP();
      await state.fetchEstadosInternos();
    } finally {
      set({ isLoading: false });
      setLoading(false);
    }
  }
})); 